import React from "react";
import { Card, CardBody } from "reactstrap";
import FeatherIcon from "feather-icons-react";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};


const IncidentDetails = () => {
  return (
    <Card className="shadow-sm border mt-4" style={cardShell}>
      <CardBody className="p-4">
        <h5 className="fw-bold mb-4">Incident Details</h5>

        {/* Incident Lead */}
        <div className="mb-4">
          <p className="text-muted mb-2" style={{ fontSize: "14px" }}>
            Incident Lead
          </p>
          <div className="d-flex align-items-center gap-2">
            <div
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                backgroundColor: "#e9ecef",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FeatherIcon icon="user" size={16} color="#6c757d" />
            </div>
            <span style={{ fontSize: "15px", fontWeight: "500" }}>Alex Chen</span>
          </div>
        </div>

        {/* Reporter */}
        <div className="mb-4">
          <p className="text-muted mb-2" style={{ fontSize: "14px" }}>
            Reporter
          </p>
          <div className="d-flex align-items-center gap-2">
            <div
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                backgroundColor: "#e9ecef",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FeatherIcon icon="user" size={16} color="#6c757d" />
            </div>
            <span style={{ fontSize: "15px", fontWeight: "500" }}>Sarah Kim</span>
          </div>
        </div>

        {/* Active Participants */}
        <div className="mb-4">
          <p className="text-muted mb-2" style={{ fontSize: "14px" }}>
            Active Participants
          </p>
          <div className="d-flex align-items-center gap-2">
            {[1, 2].map((i) => (
              <div
                key={i}
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  backgroundColor: "#e9ecef",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FeatherIcon icon="user" size={16} color="#6c757d" />
              </div>
            ))}
          </div>
        </div>

        <hr style={{ margin: "24px 0", borderColor: "#dee2e6" }} />

        {/* Slack link */}
        <div
          style={{
            color: "#FF5B00",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
          className="mb-3"
        >
          <FeatherIcon icon="slack" size={16} />
          View Slack channel
        </div>

        <hr style={{ margin: "24px 0", borderColor: "#dee2e6" }} />

        {/* Post-mortem and Debrief */}
        <div
          className="mb-3 d-flex align-items-center gap-2"
          style={{
            color: "#717981ff",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          <FeatherIcon icon="file-text" size={16} />
          Add post-mortem
        </div>

        <div
          className="d-flex align-items-center gap-2"
          style={{
            color: "#717981ff",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          <FeatherIcon icon="calendar" size={16} />
          Schedule debrief
        </div>
      </CardBody>
    </Card>
  );
};

export default IncidentDetails;
